import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Iframe from "react-iframe";
import "./footer.scss";
import MultiActionAreaCard from "./card";
import { Link } from "react-router-dom";

const Footer = () => {
  const locationTo = (location) => {
    window.location.href = location;
  };
  return (
    <>
      <div className="footer">
        <div className="logo">
          <MultiActionAreaCard />
        </div>

        <div className="routing">
          <span>Документы</span>
          <Link to="/calendar">Календарь</Link>
          <Link to="/documents">Документы</Link>
          <Link to="/polog">Положения</Link>
          <Link to="/protocol">Протоколы</Link>
          <Link to="/norm">Нормативы</Link>
          <Link to="/">Инфо</Link>
        </div>

        <div className="routing">
          <span>Спортсмены</span>
          <Link to="/albom">Фото соревнований</Link>
          <Link to="/zayavka">Отправить заявку на соревнование</Link>
          <Link to="/lk">Личный кабинет</Link>
          <Link to="/sportsmens">Наши спортсмены</Link>
          <Link to="/record">Рекорды рязанской области</Link>
          <Link to="/anti">Антидопинг</Link>
        </div>

        <div className="routing">
          <span>Контакты</span>
          <Link to="/contacts">Контакты антидопинг</Link>
          <Link to="/contacts">Контакты президента</Link>
          <Link to="/contacts">Контакты секретаря</Link>
          <Link to="/contacts">Контакты администратора</Link>
          <a href=""> Рязанская область, г Рязань, ул Спортивная, д. 19.</a>
        </div>

        <Iframe
          url="https://yandex.ru/map-widget/v1/?um=constructor%3Ae1ace87e7a0e9539cca8cd8705c9bf128d7df2aac024d214e4aa7de092682cd9&amp;source=constructor"
          display="block"
          position="relative"
          width="500"
          height="400"
        />
      </div>
    </>
  );
};

export default Footer;
